import Slider from "react-slick";
import { useEffect, useState } from "react";

// style
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Carousel.css";

const Carousel = ({ items, nbItemsToDisplay, classname }) => {

	const [isCenter, setIsCenter] = useState(false);

	useEffect(() => {
		setIsCenter(items.length > nbItemsToDisplay);
	}, [items,nbItemsToDisplay]);


	const settings = {
		dots: true,
		speed: 500,
		infinity: true,
		slidesToShow: nbItemsToDisplay,
		slidesToScroll: 1,
		// adaptiveHeight: (items.length === 1)?false:true,
		swipeToSlide: true,
		centerMode: isCenter,
		prevArrow: <></>,
		nextArrow: <></>,

	};

	return (
		<div className={classname}>
			<Slider {...settings} className={"menu-div"} >
				{items}
			</Slider>
		</div>
	);
};

export default Carousel;